import { render, staticRenderFns } from "./RegistrationCompleteModule.vue?vue&type=template&id=3aa208dc&scoped=true&"
import script from "./RegistrationCompleteModule.vue?vue&type=script&lang=js&"
export * from "./RegistrationCompleteModule.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCompleteModule.vue?vue&type=style&index=0&id=3aa208dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa208dc",
  null
  
)

export default component.exports